import { useCareTeamSelector } from './useCareTeamSelector';
import { useCallback } from 'react';
import { displayName, useDeepEqualMemo } from '@xolv-mybrightlink/common';

export const usePatientGuids = (): string[] => {
  const patientGuids = useCareTeamSelector(
    useCallback((state) => {
      if (state === 'LOADING') {
        return [];
      }
      const patients = Object.values(state.patients).sort((p1, p2) => {
        const p1Name = displayName(p1);
        const p2Name = displayName(p2);
        return p1Name.localeCompare(p2Name);
      });
      return patients.map((patient) => patient.guid);
    }, []),
  );
  return useDeepEqualMemo(patientGuids);
};

export const usePatient = (patientGuid: string) => {
  return useCareTeamSelector(
    useCallback(
      (state) => {
        return state === 'LOADING' ? null : state.patients[patientGuid] ?? null;
      },
      [patientGuid],
    ),
  );
};
